/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Bystep_TitleInputs */

const en_mk_team_bystep_title = /** @type {(inputs: Mk_Team_Bystep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Bystep AI`)
};

const id_mk_team_bystep_title = /** @type {(inputs: Mk_Team_Bystep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai AI Bystep`)
};

/**
* | output |
* | --- |
* | "Use Bystep AI" |
*
* @param {Mk_Team_Bystep_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_bystep_title = /** @type {((inputs?: Mk_Team_Bystep_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Bystep_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_bystep_title(inputs)
	return en_mk_team_bystep_title(inputs)
});